// Dependencies
import styled from 'styled-components';

const ImageStyles = styled.div`
  display: ${(props) => (props?.flex ? 'flex' : 'block')};
  flex-wrap: ${(props) => (props?.flex ? 'wrap' : 'initial')};
  align-items: ${(props) => (props?.alignItems ? props?.alignItems : '')};
  justify-content: ${(props) =>
    props?.justifyContent ? props?.justifyContent : ''};
  background-color: var(--color-${(props) => props?.backgroundColor});

  & > * {
    background-color: var(--color-${(props) => props?.backgroundColor});

    ${(props) =>
      props?.background &&
      `
      position: absolute;
      top: 0;
      left: 0;
      z-index: -2;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: -2;
    `}
  }

  .filtered::before {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 100%;
    pointer-events: none;
    background-color: var(--color-bark);
    opacity: 0.4;
  }
`;

export default ImageStyles;
